import React from 'react';
import styled from '@emotion/styled';
import { TourTrashUserType } from '../../../../types/tourtrash';
import { SubscriptionPlan } from '../../../../types/accessCode';

interface Props {
  record: TourTrashUserType;
}

export default React.memo((props: Props) => {
  const { record } = props;
  return (
    <StyledContainer>
      {record.myTMSubscriptionLevel === 0 && <span>{SubscriptionPlan.FREE}</span>}
      {record.myTMSubscriptionLevel === 1 && <span>{SubscriptionPlan.CHAMPION}</span>}
      {record.myTMSubscriptionLevel === 2 && <span>{SubscriptionPlan.LEGEND}</span>}
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  padding-left: 0.5rem;
`;
